/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  NFTIVMarketplace721Upgradeable,
  NFTIVMarketplace721UpgradeableInterface,
} from "../../../../packages/marketplace-721/contracts/NFTIVMarketplace721Upgradeable";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "nftContractAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "auctionSettler",
        type: "address",
      },
    ],
    name: "AuctionSettled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "nftContractAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftOwner",
        type: "address",
      },
    ],
    name: "AuctionWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "nftContractAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "bidder",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ethAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "erc20Token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256",
      },
    ],
    name: "BidMade",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "nftContractAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "buyer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ethAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "erc20Token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256",
      },
    ],
    name: "BuyMade",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "nftContractAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "HighestBidTaken",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "nftContractAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftSeller",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "nftHighestBid",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftHighestBidder",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftRecipient",
        type: "address",
      },
    ],
    name: "NFTTransferredAndSellerPaid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "nftContractAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftSeller",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "erc20Token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "minPrice",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "auctionEnd",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "bidIncreasePercentage",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "string",
        name: "identifier",
        type: "string",
      },
    ],
    name: "NftAuctionCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "nftContractAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftSeller",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "erc20Token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "buyNowPrice",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "string",
        name: "identifier",
        type: "string",
      },
    ],
    name: "SaleCreated",
    type: "event",
  },
  {
    inputs: [],
    name: "commissionPercentage",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "commissionReceiver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftContractAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_erc20Token",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_minPrice",
        type: "uint128",
      },
      {
        internalType: "uint64",
        name: "_auctionEnd",
        type: "uint64",
      },
      {
        internalType: "uint32",
        name: "_bidIncreasePercentage",
        type: "uint32",
      },
      {
        internalType: "string",
        name: "_identifier",
        type: "string",
      },
    ],
    name: "createAuction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftContractAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_erc20Token",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_buyNowPrice",
        type: "uint128",
      },
      {
        internalType: "string",
        name: "_identifier",
        type: "string",
      },
    ],
    name: "createSale",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultBidIncreasePercentage",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_commissionReceiver",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftContractAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_erc20Token",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_tokenAmount",
        type: "uint128",
      },
    ],
    name: "makeBid",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftContractAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_erc20Token",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_tokenAmount",
        type: "uint128",
      },
    ],
    name: "makeBuy",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "maximumMinPricePercentage",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minimumSettableIncreasePercentage",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftContractAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOfNFT",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftContractAddress",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "_tokenArray",
        type: "uint256[]",
      },
    ],
    name: "resetAllOrders",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_newPercentage",
        type: "uint32",
      },
    ],
    name: "setCommissionPercentage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newReceiver",
        type: "address",
      },
    ],
    name: "setCommissionReceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftContractAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "settleAuction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftContractAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "takeHighestBid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawAllFailedCredits",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftContractAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "withdrawAuction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type NFTIVMarketplace721UpgradeableConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NFTIVMarketplace721UpgradeableConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NFTIVMarketplace721Upgradeable__factory extends ContractFactory {
  constructor(...args: NFTIVMarketplace721UpgradeableConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<NFTIVMarketplace721Upgradeable> {
    return super.deploy(
      overrides || {}
    ) as Promise<NFTIVMarketplace721Upgradeable>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): NFTIVMarketplace721Upgradeable {
    return super.attach(address) as NFTIVMarketplace721Upgradeable;
  }
  override connect(signer: Signer): NFTIVMarketplace721Upgradeable__factory {
    return super.connect(signer) as NFTIVMarketplace721Upgradeable__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NFTIVMarketplace721UpgradeableInterface {
    return new utils.Interface(_abi) as NFTIVMarketplace721UpgradeableInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NFTIVMarketplace721Upgradeable {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as NFTIVMarketplace721Upgradeable;
  }
}
